import { useTheme } from "@hooks";
import { CSSProperties } from "react";

const PROGRESS_BAR_HEIGHT = 10;

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    background: {
      backgroundColor: theme.body.background,
    },
    bar: {
      height: PROGRESS_BAR_HEIGHT,
      backgroundColor: theme.progress.default,
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
    },
  };

  return styles;
};
